module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/tutorial1_2b2258.jpg";